import { Donate } from 'react-kofi-overlay';
import Backdrop from '@mui/material/Backdrop';
import PhoneMTGMap from './PhoneMTGMap';
import { IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Info from './InfoPhone';
import infoPre from '../data/tutorial.png';


function MobileDisplay({setStart, useColors, currentCoord, handleChange, setOpen, isOpen, start}) {

  return (
    <div className="App" style={{position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden'}}>
        <Backdrop
            sx={{
                color: '#ffffff00',
                zIndex: 20,
                height: '100vh',
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
            }}
            open={start}
            onClick={() => {sessionStorage.setItem('firstTime', false); setStart(false)}}
        >
            <Box>
                <IconButton style={{position: 'absolute',top: '10px',right: '10px',color: 'white',backgroundColor: '#ccccccbb', zIndex: 10}} onClick={() => {setStart(false) }}>
                        <CloseIcon />
                </IconButton>
                
            </Box>
            <img src={infoPre} alt="card before clicking" style={{width: '100%', height: 'auto', position: 'flex', zIndex: 5}}></img>
            </Backdrop>
        <PhoneMTGMap useColors={useColors} currentCoord={currentCoord} handleChange={handleChange} setOpen={setOpen} open={isOpen}/>
        <Donate
            username="martirubio"
            classNames={{
                donateBtn: 'myDonateButton',
                profileLink: 'myProfileLink',
            }}
            styles={{
                donateBtn: {
                    position: 'absolute',
                    // color: 'black',
                    right: '3%',
                    bottom: '3%',
                    background: '#01204E'
                },
                panel: {
                    position: 'absolute',
                    // color: 'black',
                    height: '96%',
                    right: '2%',
                    borderRadius: '100px',
                    background: '#01204E'
                },
                fontFamily: 'Montserrat, sans-serif'
            }}
        >
            <div style={{fontFamily: 'Montserrat, sans-serif'}}>
                {"🥳 Support Me"}
            </div>
        </Donate>
        <Backdrop
                sx={{
                    color: '#ffffff00',
                    zIndex: 1,
                    height: '100vh',
                    width: '100vw',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
                open={isOpen}
                onClick={() => setOpen(false)}
            >
            {isOpen && <Info sx={{zIndex: 2}} setOpen={setOpen} phone={true}></Info>}
        </Backdrop>
    </div>
  );
}

export default MobileDisplay;
